import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiUser,FiHeart}=FiIcons;

const StorySection=()=> {
  return (
    <section id="story" className="story-section">
      <div className="container mx-auto px-6 py-20">
        <div className="story-content">
          <motion.div className="story-text" initial={{x: -30,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} >
            <div className="story-badge">
              <SafeIcon icon={FiHeart} />
              <span>Built by someone like you</span>
            </div>
            <h2 className="story-title">
              Theater nerd. Founder. Operations exec. AuDHD.
            </h2>
            <div className="story-text-content">
              <p>
                I spent 24 years in theater. Acting, singing, teaching, managing. I learned to think in layers, work in rhythm, hold multiple threads at once.
              </p>
              <p>
                Then I became a founder AND an operations VP. Same time. Same brain. I'm AuDHD. Black woman in my 40s. Theater nerd who codes. I have a thousand ideas and a thousand responsibilities.
              </p>
              <p>
                And I got tired of productivity tools built for brains that think in straight lines.
              </p>
              <div className="story-highlight">
                <p>
                  <strong>Here's what I realized:</strong> I don't think in straight lines. I think in systems and patterns and ensemble energy. I need structure, but not rigidity. I need clarity, but not oversimplification.
                </p>
                <p>
                  <strong>And I know I'm not alone.</strong>
                </p>
              </div>
              <p>
                MindFlow is what I built for myself—and for every other founder, creative, and multi-hyphenated human who's tired of pretending their brain works like everyone else's.
              </p>
            </div>
          </motion.div>
          <motion.div className="story-visual" initial={{x: 30,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8,delay: 0.2}} viewport={{once: true}} >
            <div className="founder-card">
              <div className="founder-avatar">
                <SafeIcon icon={FiUser} />
              </div>
              <div className="founder-info">
                <h4>Multi-hyphenated Human</h4>
                <div className="founder-tags">
                  <span className="tag">Theater Nerd</span>
                  <span className="tag">Founder</span>
                  <span className="tag">Operations VP</span>
                  <span className="tag">AuDHD</span>
                  <span className="tag">Black Woman</span>
                  <span className="tag">Codes</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;